import {useRouter} from 'next/router';
import {useState} from 'react';
import {useGetEntryReadyRecommends} from '../../../core/repositories/recruitmentRepository';
import {useAuth} from '../../../core/usecases/auth/AuthContext';
import {useIsAppWebView} from '../../../shared/hooks/useIsAppWebView';
import {useMarkPromptAsShown} from '../../../shared/hooks/useMarkPromptAsShown';
import {canRequestPostRegisterEntryPrompt} from './canRequestPostRegisterEntryPrompt';

export const POST_REGISTER_ENTRY_PROMPT_MESSAGE_TYPE =
  'post_register_entry_prompt';

export const usePostRegisterEntryPrompt = () => {
  const {status} = useAuth();
  const isAppWebView = useIsAppWebView();
  const router = useRouter();
  const [isClosed, setIsClosed] = useState(false);

  const canRequest = canRequestPostRegisterEntryPrompt({
    isAuthenticated: status === 'authenticated',
    isAppWebView,
    pathname: router.pathname,
  });

  const {data, isLoading} = useGetEntryReadyRecommends({
    config: {enabled: canRequest},
  });
  // 対象外のユーザーにはAPIが空配列を返すので、件数だけで表示可否が決まる
  const recruitments = data?.ok ? data.value.recruitments : [];
  const basedOnWishIndustries = data?.ok
    ? data.value.basedOnWishIndustries
    : false;
  const opened = canRequest && !isClosed && recruitments.length > 0;
  // 判定確定前に他のポップアップが先に開いてしまうのを防ぐ
  const isDeciding = canRequest && isLoading;

  useMarkPromptAsShown({
    opened,
    messageType: POST_REGISTER_ENTRY_PROMPT_MESSAGE_TYPE,
  });

  return {
    opened,
    isDeciding,
    recruitments,
    basedOnWishIndustries,
    close() {
      setIsClosed(true);
    },
  };
};
